
import { app } from "@/config/firebase";
import { getFirestore } from "firebase/firestore";
import { collection, addDoc } from "firebase/firestore";
import _ from 'lodash';

// Initialize Firebase
const db = getFirestore(app);

async function addInquiry(inquiry) {
    try {
        const docRef = await addDoc(collection(db, "inquiries"), inquiry);
        console.log("Document written with ID: ", docRef.id);
        return docRef.id;
    } catch (e) {
        console.error("Error adding document: ", e);
        return null;
    }
}

export default {
    addInquiry
}